import {Service} from '@s-ui/domain'

export class GetRequestSearchService extends Service {
  constructor({config, fromSearchParamsToRequestVOMapper}) {
    super()
    this._config = config
    this._fromSearchParamsToRequestVOMapper = fromSearchParamsToRequestVOMapper
  }

  async execute({query, context}) {
    return this._fromSearchParamsToRequestVOMapper.map({query, context})
  }
}
